import { Component, OnInit } from '@angular/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ModalAddValueFormByIdComponent } from '../modals/modal-add-value-form-by-id/modal-add-value-form-by-id.component';
import { MedicalMisurationType } from '../misuration/misuration.component';

import { TrendComponent } from '../utility/trend/trend.component';
import { DataService } from '../../services/data.service';
import { MedicalDataDTO } from '../../classes/api-dto';

@Component({
  selector: 'app-medical-data',
  imports: [NzTableModule, TranslateModule, TrendComponent],
  templateUrl: './medical-data.component.html',
  styleUrls: ['./medical-data.component.scss'],
})
export class MedicalDataComponent implements OnInit {
  medicalDataModelled: any; /* Tipizzare */

  readonly idData: MedicalMisurationType[] = ['weight', 'waistCircumference', 'height', 'isSmoker', 'bloodGroup', 'hipCircumference', 'wristCircumference'];

  constructor(
    private modal: NzModalService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getMedicalProfileData();
  }

  private getMedicalProfileData(): void {
    this.dataService.getMedicalData().subscribe((medicalDataService: MedicalDataDTO) => {
      this.modelMedicalData(medicalDataService);
    });
  }

  private modelMedicalData(medicalData: MedicalDataDTO): void {
    this.medicalDataModelled = {
      firstMeasurement: {
        weight: { value: medicalData?.firstMeasurement?.weight, measure_unit: 'kg' },
        height: { value: medicalData?.firstMeasurement?.height, measure_unit: 'cm' },
        waistCircumference: { value: medicalData?.firstMeasurement?.waistCircumference, measure_unit: 'cm' },
        hipCircumference: { value: medicalData?.firstMeasurement?.hipCircumference, measure_unit: 'cm' },
        wristCircumference: { value: medicalData?.firstMeasurement?.wristCircumference, measure_unit: 'cm' },
        bloodGroup: { value: medicalData?.firstMeasurement?.bloodGroup },
        isSmoker: { value: this.checkTextSmoker(medicalData?.firstMeasurement?.isSmoker) },
        lastTimeModified: medicalData?.firstMeasurement?.lastTimeModified,
      },
      lastMeasurement: {
        weight: { value: medicalData?.lastMeasurement?.weight, measure_unit: 'kg' },
        height: { value: medicalData?.lastMeasurement?.height, measure_unit: 'cm' },
        waistCircumference: { value: medicalData?.lastMeasurement?.waistCircumference, measure_unit: 'cm' },
        hipCircumference: { value: medicalData?.lastMeasurement?.hipCircumference, measure_unit: 'cm' },
        wristCircumference: { value: medicalData?.lastMeasurement?.wristCircumference, measure_unit: 'cm' },
        bloodGroup: { value: medicalData?.lastMeasurement?.bloodGroup },
        isSmoker: { value: this.checkTextSmoker(medicalData?.lastMeasurement?.isSmoker) },
        lastTimeModified: medicalData?.lastMeasurement?.lastTimeModified,
      },
    };
  }

  protected addData(graphModified: MedicalMisurationType): void {
    const modalRef: NzModalRef<ModalAddValueFormByIdComponent> = this.modal.create({
      nzContent: ModalAddValueFormByIdComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: { id: graphModified },
      },
    });
    /* TODO: va implementato un comportamento dopo la chiusura della modale? */
    //modalRef.afterClose.subscribe((result): void => {
    //});
  }

  protected checkTextSmoker(element?: boolean): string {
    if (typeof element === 'boolean') {
      if (element) {
        return 'medicalData.yes';
      }
      return 'medicalData.no';
    }
    return '';
  }
}
